import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';

import FieldUtil from '../utils/FieldNames';

import '../../../../app/assets/stylesheets/rte_edit_payer.scss';
import { ErrorMessage } from 'formik';

class TwoSeventySection extends Component {
  displayValue(object, fields) {
    const data = _.get(object, [...fields]);
    if (data === false) {
      return 'false';
    }
    return data ? data.toString() : '---';
  }

  renderLoopData() {
    return (
      <div className="loop_data">
        <div className="fields">
          {FieldUtil.loopFields.map((loopField, i) => (
            <div className="loop_field_row" key={i}>{loopField}</div>
          ))}
        </div>
        <div className="field_values">
          {FieldUtil.loopFields.map((loopField, i) => (
            <div className="loop_field_row" key={i}>
              {this.displayValue(this.props.twoSeventyData, [loopField])}
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderLoops() {
    return (
      <div className="loops">
        {FieldUtil.loopFieldKeys.map((loop, i) => (
          <div className="loop" key={i}>
            <div className="cost_rules">
              <p><b>{FieldUtil.transformName(loop)}</b></p>
            </div>
            {this.renderLoopData()}
          </div>
        ))}
      </div>
    );
  }

  renderSpecialtyData(specialty) {
    return (
      <div className="specialty_data">
        <div className="fields">
          {FieldUtil.twoSeventySpecialtySubkeys.map((specialtySubKey, i) => (
            <div className="specialty_field_row" key={i}>{specialtySubKey}</div>
          ))}
        </div>
        <div className="field_values">
          {FieldUtil.twoSeventySpecialtySubkeys.map((specialtySubKey, i) => (
            <div className="specialty_field_row" key={i}>
              {this.displayValue(this.props.twoSeventyData, [specialty, specialtySubKey])}
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderSpecialties() {
    return (
      <div className="specialties">
        {FieldUtil.specialtyKeys.map((specialty, i) => (
          <div className="specialty" key={i}>
            <div className="cost_rules">
              <p>
                <b>{specialty.toLocaleUpperCase()}</b>
              </p>
            </div>
            {this.renderSpecialtyData(specialty)}
          </div>
        ))}
      </div>
    );
  }

  renderSection() {
    return (
      <div>
        <div className="two_seventy_section">
          <div className="fields">
            {FieldUtil.twoSeventyFields.map((field, i) => (
              <div className="cost_rules" key={i}>
                <p><b>{FieldUtil.transformName(field)}</b></p>
              </div>
            ))}
          </div>
          <div className="field_values">
            {FieldUtil.twoSeventyFields.map((field, i) => (
              <div className="cost_rules" key={i}>
                <p>{this.displayValue(this.props.twoSeventyData, [field])}</p>
              </div>
            ))}
          </div>
        </div>
        {this.renderLoops()}
        {this.renderSpecialties()}
      </div>
    );
  }

  render() {
    return (
      <div>
        <ErrorMessage
          name="sections.two_seventy"
          render={msg => <div className="error">{msg}</div>}
        />
        {this.renderSection()}
      </div>
    );
  }
}

TwoSeventySection.propTypes = {
  visibleSection:       PropTypes.string,
  twoSeventyData:       PropTypes.object,
  supportedSpecialties: PropTypes.string
};

export default TwoSeventySection;
